<nb-card class="billing-details-dialog">
  <nb-card-header>
    <h4>{{ "dialogs.billingDetails.title" | translate }}</h4>
  </nb-card-header>

  <nb-card-body>
    @if (incomplete) {
    <p class="notice">
      <nb-icon icon="info-outline"></nb-icon>
      <span>{{ "dialogs.billingDetails.incomplete" | translate }}</span>
    </p>
    }
    <p class="intro">{{ "dialogs.billingDetails.intro" | translate }}</p>

    <form [formGroup]="form" (ngSubmit)="confirm()">
      <div class="field">
        <label for="bd_company" class="label">{{ "dialogs.billingDetails.company" | translate }}</label>
        <input
          id="bd_company"
          type="text"
          nbInput
          fullWidth
          formControlName="company_name"
          placeholder="{{ 'input.name.placeholderCompany' | translate }}"
          [status]="showInputError('company_name') ? 'danger' : 'basic'"
        />
        @if (showInputError('company_name')) {
        <p class="field-hint field-hint--error">{{ "dialogs.billingDetails.required" | translate }}</p>
        }
      </div>

      <app-address-autocomplete
        (addressResolved)="applyResolved($event)"
      ></app-address-autocomplete>

      <div class="row row--wide-first">
        <div class="field">
          <label for="bd_street" class="label">{{ "input.street.label" | translate }}</label>
          <input
            id="bd_street"
            type="text"
            nbInput
            fullWidth
            formControlName="street"
            placeholder="{{ 'input.street.placeholder' | translate }}"
            [status]="showInputError('street') ? 'danger' : 'basic'"
          />
          @if (showInputError('street')) {
          <p class="field-hint field-hint--error">{{ "dialogs.billingDetails.required" | translate }}</p>
          }
        </div>
        <div class="field">
          <label for="bd_number" class="label">{{ "input.houseNumber.label" | translate }}</label>
          <input
            id="bd_number"
            type="text"
            nbInput
            fullWidth
            maxlength="13"
            formControlName="number"
            placeholder="{{ 'input.houseNumber.placeholder' | translate }}"
            [status]="showInputError('number') ? 'danger' : 'basic'"
          />
          @if (showInputError('number')) {
          <p class="field-hint field-hint--error">{{ "dialogs.billingDetails.required" | translate }}</p>
          }
        </div>
      </div>

      <div class="row row--short-first">
        <div class="field">
          <label for="bd_zip" class="label">{{ "input.postalCode.label" | translate }}</label>
          <input
            id="bd_zip"
            type="text"
            nbInput
            fullWidth
            formControlName="zip"
            placeholder="{{ 'input.postalCode.placeholder' | translate }}"
            [status]="showInputError('zip') ? 'danger' : 'basic'"
          />
          @if (showInputError('zip')) {
          <p class="field-hint field-hint--error">{{ "dialogs.billingDetails.required" | translate }}</p>
          }
        </div>
        <div class="field">
          <label for="bd_city" class="label">{{ "input.city.label" | translate }}</label>
          <input
            id="bd_city"
            type="text"
            nbInput
            fullWidth
            formControlName="city"
            placeholder="{{ 'input.city.placeholder' | translate }}"
            [status]="showInputError('city') ? 'danger' : 'basic'"
          />
          @if (showInputError('city')) {
          <p class="field-hint field-hint--error">{{ "dialogs.billingDetails.required" | translate }}</p>
          }
        </div>
      </div>

      <div class="field">
        <label for="bd_country" class="label">{{ "input.country.label" | translate }}</label>
        <nb-select
          id="bd_country"
          formControlName="country_code"
          [fullWidth]="true"
          [status]="showInputError('country_code') ? 'danger' : 'basic'"
          placeholder="{{ 'input.country.placeholder' | translate }}"
        >
          <nb-option *ngFor="let c of countries" [value]="c.code">
            {{ countryLabel(c.code) }}
          </nb-option>
        </nb-select>
        @if (showInputError('country_code')) {
        <p class="field-hint field-hint--error">{{ "dialogs.billingDetails.requiredCountry" | translate }}</p>
        }
      </div>

      <div class="field">
        <label for="bd_vat" class="label">{{ "input.vatId.label" | translate }}</label>
        <input
          id="bd_vat"
          type="text"
          nbInput
          fullWidth
          formControlName="vat_id"
          placeholder="{{ 'input.vatId.placeholder' | translate }}"
          [status]="showInputError('vat_id') ? 'danger' : 'basic'"
        />
        @if (vatIdErrorKey) {
        <p class="field-hint field-hint--error">{{ vatIdErrorKey | translate }}</p>
        } @else {
        <p class="field-hint">
          {{
            (vatIdRequired
              ? "dialogs.billingDetails.vatHintEu"
              : "dialogs.billingDetails.vatHint"
            ) | translate
          }}
        </p>
        }
      </div>

      @if (taxStatusKey) {
      <div class="tax-status">
        <span class="label">{{ "input.taxStatus.label" | translate }}</span>
        <p>{{ taxStatusKey | translate }}</p>
      </div>
      }
    </form>

    @if (errorKey) {
    <p class="error">{{ errorKey | translate }}</p>
    }
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="basic"
      type="button"
      [disabled]="saving"
      (click)="dialogRef.close(false)"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      type="button"
      [nbSpinner]="saving"
      [disabled]="saving"
      (click)="confirm()"
    >
      {{ "dialogs.billingDetails.confirm" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
